export default {
  "app-protected": () => import("/opt/build/repo/layouts/AppProtected.vue").then(m => m.default || m),
  "app-public": () => import("/opt/build/repo/layouts/AppPublic.vue").then(m => m.default || m),
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m),
  blog: () => import("/opt/build/repo/domains/blog/layouts/Blog.vue").then(m => m.default || m),
  "blog-overview": () => import("/opt/build/repo/domains/blog/layouts/BlogOverview.vue").then(m => m.default || m)
}